import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import SweetModalTab  from 'sweet-modal-vue/src/plugin.js'
Vue.use(SweetModal)
Vue.use(SweetModalTab )
Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyBUi66eMnOGYVnZ45vjGWkrRLMPXQQsIPU",
  authDomain: "covidquiz-726d1.firebaseapp.com",
  databaseURL: "https://covidquiz-726d1.firebaseio.com",
  projectId: "covidquiz-726d1",
  storageBucket: "covidquiz-726d1.appspot.com",
  messagingSenderId: "869328205235",
  appId: "1:869328205235:web:2b0dbf825e97a293f747c6",
  measurementId: "G-EWP5VFZ310"
};

firebase.initializeApp(firebaseConfig);
firebase.auth().settings.appVerificationDisabledForTesting = true;

var vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
